/**
 * Asserts that the given object has the `never` type indicating all branches of
 * the union have been consumed.
 * @param input to assert does not exist
 * @throws when executed, this is a runtime enforcement of a type level check.
 */
export function assertNever(input: never): never {
  throw new Error(`Received input ${input}`);
}
